import React, { useState, useEffect, useRef } from "react";
import { useNavigate } from "react-router-dom";
import HeaderBar from './Component/Header1';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faHeart, faPlus, faMinus, faImage } from '@fortawesome/free-solid-svg-icons';
import ViewBucket from './Component/ViewBucket';
import defaultimg from './images/defaultimg.png';

const SavedItemsPage = () => {
  const navigate = useNavigate();
  const [items, setItems] = useState([]);
  const imgRefs = useRef({});
  const bucketRef = useRef(null);
  const [bucketProducts, setBucketProducts] = useState({});
  const [showViewBucket, setShowViewBucket] = useState(false);

  useEffect(() => {
    const savedItems = JSON.parse(sessionStorage.getItem("savedItems")) || [];
    setItems(savedItems);
  }, []);

  useEffect(() => {
    const fetchBucketProducts = () => {
      const savedBucketProducts = localStorage.getItem("bucketProducts");
      if (savedBucketProducts) {
        const products = JSON.parse(savedBucketProducts);
        setBucketProducts(products);
        setShowViewBucket(Object.keys(products).length > 0);
      } else {
        setBucketProducts({});
        setShowViewBucket(false);
      }
    };

    fetchBucketProducts();
  }, []);

  const handleRemoveItem = (itemId) => {
    const updatedItems = items.filter(item => item.id !== itemId);
    setItems(updatedItems);
    sessionStorage.setItem("savedItems", JSON.stringify(updatedItems));
  };

 const handleQuantityChange = (itemId, action) => {
  setItems(prevItems => {
    const updatedItems = prevItems.map(item => {
      if (item.id === itemId) {
        let newQuantity = item.quantity || 0;

        if (action === 'increase') newQuantity += 1;
        else if (action === 'decrease' && newQuantity > 0) newQuantity -= 1;

        // ⭐ SYNC CART QUANTITY ⭐
        const bucket = JSON.parse(localStorage.getItem("bucketProducts") || "{}");
        if (bucket[itemId]) {
          bucket[itemId].quantity = newQuantity;
          localStorage.setItem("bucketProducts", JSON.stringify(bucket));
          setBucketProducts(bucket);
        }
        // ⭐ END SYNC ⭐

        return { ...item, quantity: newQuantity };
      }
      return item;
    });

    sessionStorage.setItem("savedItems", JSON.stringify(updatedItems));

    // Your existing code (add/update bucket items)
    const updatedBucketProducts = { ...bucketProducts };
    updatedItems.forEach(item => {
      if (item.quantity > 0) {
        updatedBucketProducts[item.id] = {
          _id: item.id,
          product_name: item.name,
          product_image: item.image.replace(process.env.REACT_APP_FORE_BRICKBUCKET_IMAGES, ''),
          selling_price: typeof item.price === 'string'
            ? parseFloat(item.price.replace('₹', '').replace(',', '')) || 0
            : item.price || 0,
          quantity: item.quantity,
          product_category_id: item.categoryId,
          GST: item.GST || 0,
          UOM_id: item.UOM_id || null,
          uom: item.uom || null,
        };
      } else {
        delete updatedBucketProducts[item.id];
      }
    });

    localStorage.setItem('bucketProducts', JSON.stringify(updatedBucketProducts));
    setBucketProducts(updatedBucketProducts);
    setShowViewBucket(Object.keys(updatedBucketProducts).length > 0);

    return updatedItems;
  });
};



  const handleAddToBucket = (item) => {
  // Set quantity to 1 and add to bucket
  setItems(prevItems => {
    const updatedItems = prevItems.map(i => 
      i.id === item.id ? { ...i, quantity: 1 } : i
    );
    sessionStorage.setItem("savedItems", JSON.stringify(updatedItems));
    return updatedItems;
  });
  // Add to bucketProducts with proper structure (matching ProductSearchOverlay format)
  const updatedBucketProducts = {
    ...bucketProducts,
    [item.id]: {
      _id: item.id,
      product_name: item.name,
      product_image: item.image.replace(process.env.REACT_APP_FORE_BRICKBUCKET_IMAGES, ''), // Store filename, not full URL
      selling_price: typeof item.price === 'string' ? parseFloat(item.price.replace('₹', '').replace(',', '')) || 0 : item.price || 0,
      quantity: 1,
 product_category_id: item.categoryId,      // Add other necessary fields if available
      UOM_id: item.UOM_id || null,
      uom: item.uom || null,
      // If more fields are needed, add them here
    }
  };
  localStorage.setItem('bucketProducts', JSON.stringify(updatedBucketProducts));
  setBucketProducts(updatedBucketProducts);
  setShowViewBucket(true);
};

  return (
    <div className="min-h-screen bg-gray-50 ">
      {/* Header */}
      <HeaderBar
         title="Saved List" 
          showSearch={false}
   />

      {/* Products Grid */}
      <div className="grid grid-cols-3 px-3 gap-2 mt-4 mb-4">
        {items.length > 0 ? (
          items.map(item => (
            <div key={item.id} className="flex flex-col mb-4">
              {/* Gray container with image */}
              <div className="relative rounded-lg bg-gray-100 overflow-hidden mx-1">
              <div className="h-24 flex items-center justify-center p-3 relative">
  {/* Fallback icon (always there) */}
 <img
  ref={(el) => (imgRefs.current[item.id] = el)}
  src={item.image ? item.image : defaultimg}
  alt={item.name}
  onError={(e) => {
    e.currentTarget.src = defaultimg;
  }}
  className={`h-full w-full object-contain cursor-pointer hover:scale-105 transition-transform duration-200 relative ${
    item.image ? "" : "bg-gray-100"
  }`}
/>
</div>

                {/* Heart Icon */}
                <button
                  onClick={() => handleRemoveItem(item.id)}
                  className="absolute top-1 right-1.5 h-6 w-6 flex items-center justify-center 
                             bg-white rounded-full shadow-md border border-gray-100 
                             hover:bg-red-50 transition"
                >
                  <FontAwesomeIcon icon={faHeart} className="text-red-500 text-md" />
                </button>

                {/* Quantity Controls or ADD Button */}
                {(item.quantity || 0) > 0 ? (
                  <div className="absolute bottom-2 right-1.5 flex items-center bg-red-500 rounded-md overflow-hidden">
                    <button
                      onClick={() => handleQuantityChange(item.id, 'decrease')}
                      className="w-5 h-6 flex items-center justify-center text-white text-xs"
                    >
                      <FontAwesomeIcon icon={faMinus} />
                    </button>
                    <span className="px-1.5 py-0.5 text-xs text-white font-semibold">{item.quantity}</span>
                    <button
                      onClick={() => handleQuantityChange(item.id, 'increase')}
                      className="w-5 h-6 flex items-center justify-center text-white text-xs"
                    >
                      <FontAwesomeIcon icon={faPlus} />
                    </button>
                  </div>
                ) : (
                  <button
                    onClick={() => handleAddToBucket(item)}
                    className="absolute bottom-2 right-1.5 bg-red-500 text-white text-xs font-semibold px-2 py-1 rounded-md"
                  >
                    ADD
                  </button>
                )}
              </div>

              {/* Product Info */}
              <div className="flex flex-col items-start mx-1 mt-1">
                <h3 className="text-xs font-medium text-[#000000] mb-1 line-clamp-2 leading-snug text-left">
                  {item.name}
                </h3>
                <p className="text-sm text-[#170101] font-semibold">
                  ₹{item.price?.toLocaleString()}
                </p>
              </div>
            </div>
          ))
        ) : (
        <div className="col-span-3 flex justify-center px-3 mt-6">
  <div className="w-full bg-white rounded-xl shadow-sm py-10 flex flex-col items-center">

    {/* Minimal icon */}
    {/* <svg
      xmlns="http://www.w3.org/2000/svg"
      className="w-14 h-14 text-gray-300"
      fill="none"
      viewBox="0 0 24 24"
      stroke="currentColor"
      strokeWidth="1.4"
    >
      <path
        strokeLinecap="round"
        strokeLinejoin="round"
        d="M12 4v16m8-8H4"
      />
    </svg> */}

    {/* Title */}
    <h3 className="text-gray-700 font-semibold text-lg mt-4">
      No Saved Items
    </h3>

    {/* Subtitle */}
    <p className="text-gray-500 text-sm mt-1 text-center px-6">
      Start adding items you want to save or buy later.
    </p>

    {/* Add Items Button */}
    <button
      onClick={() => navigate("/consumer/productcategories")}
      className="mt-5 bg-red-500 text-white px-4 py-2 rounded-lg text-sm font-medium shadow hover:bg-red-600 transition"
    >
      Add Items
    </button>

  </div>
</div>

        )}
      </div>

      {showViewBucket && (
        <ViewBucket
          ref={bucketRef}
          bucketProducts={bucketProducts}
          imageUrl={process.env.REACT_APP_FORE_BRICKBUCKET_IMAGES}
        />
      )}
    </div>
  );
};

export default SavedItemsPage;
